import React, { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import AdagioSwiper from 'js/components/AdagioSwiper';

import './fullslider.scss';

const FullSlider = ({
  results,
  active,
  onSelectSliderItem,
  isDestination,
  itemComponent: SlideItem,
  loading,
}) => {
  const swiperRef = useRef(null)

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(active - 1)
    }
  }, [active])

  const handleSlideChange = useCallback((swiper) => {
    const nextSlideData = results[swiper.activeIndex]
    if (nextSlideData) {
      onSelectSliderItem(nextSlideData?.id)
    }
  }, [results, onSelectSliderItem])

  return (
    <div className="map-slider">
      <div className="slide-wrapper">
        <AdagioSwiper
          skipNavigation
          skipPagination
          slidesPerView="auto"
          className="map-slider__swiper"
          spaceBetween={24}
          slideToClickedSlide
          initialSlide={active - 1}
          onSwiper={(swiper) => { swiperRef.current = swiper }}
          onSlideChange={handleSlideChange}
        >
          {results.map((item) => (
            <SlideItem
              isDestination={isDestination}
              loading={loading}
              key={item.id}
              item={item}
            />
          ))}
        </AdagioSwiper>
      </div>
    </div>
  )
}

FullSlider.propTypes = {
  results: PropTypes.arrayOf(PropTypes.object).isRequired,
  active: PropTypes.number.isRequired,
  onSelectSliderItem: PropTypes.func.isRequired,
  isDestination: PropTypes.bool.isRequired,
  itemComponent: PropTypes.elementType.isRequired,
  loading: PropTypes.bool,
}

export default React.memo(FullSlider)
